import styled from 'styled-components';

import { useFeatureFlag } from '~/src/common/services/FeatureFlag';

import AppsflyerSmartBanner from './AppsflyerSmartBanner';
import Copernic from './Copernic';
import Didomi from './Didomi';
import GoogleTagManager from './GoogleTagManager';
import Trustpilot from './Trustpilot';
import Zendesk from './Zendesk';

const NoScript = styled.noscript`
  display: block;
  padding: 8px 16px;
  text-align: center;
  background-color: #f0dc23;
`;

const BodyScripts = () => {
  const isCopernicEnabled = useFeatureFlag('copernic-chatbot');

  return (
    <>
      <NoScript>JavaScript est nécessaire au bon fonctionnement du site web.</NoScript>
      <Didomi />
      <GoogleTagManager />
      <AppsflyerSmartBanner />
      <Trustpilot />
      {isCopernicEnabled ? <Copernic /> : <Zendesk />}
    </>
  );
};

export default BodyScripts;
